import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, Platform } from 'react-native'
import {check, request, PERMISSIONS, RESULTS} from '../Components'
import { Camera, useCameraDevice, useCodeScanner } from '../Components'
import { Space, Button } from '@sart/components'
import { useContent } from '@sart/content'
import { backgroundColors, colors } from '@sart/styles'

function CameraComponent(props) {
    const content = useContent()
    const device = useCameraDevice('back')
	const barcodefitvalue = 5
    const {
        barCodeProcessed
    } = props
    const [hasCameraPermission, setCameraPermissions] = useState(false)
    const [scanned, setScanned] = useState(false)
	const [barcodeValues, setBarcodeValues] = useState([])

    useEffect(() =>  {
        getPermissionsAsync()
    }, [])

    const getPermissionsAsync = async () => {
        let status = undefined
        if(Platform.OS === 'android') {
                status = await check(PERMISSIONS.ANDROID.CAMERA)
                if(status === RESULTS.DENIED){
                        status = await request(PERMISSIONS.ANDROID.CAMERA)
                }
        } else if (Platform.OS === 'ios') {
                status = await check(PERMISSIONS.IOS.CAMERA)
                if(status === RESULTS.DENIED){
                        status = await request(PERMISSIONS.IOS.CAMERA)
                }
        } else {
                //This shouldn't be hit, if they aren't iOS or Android...
                status = RESULTS.DENIED
        }
        setCameraPermissions(status === RESULTS.GRANTED) 
    }

    function handleBarCodeScanned(data) {
        if(data != undefined) {
            let scannedData = data[0]
            let currentBarcode = data[0].value.substring(0, 19)
            let oldBarcodeValues = barcodeValues
            if(oldBarcodeValues.filter((v) => (v === currentBarcode)).length ===  barcodefitvalue) {
                setScanned(true)
                barCodeProcessed(scannedData)
            } else {
                oldBarcodeValues.push(currentBarcode)
                setBarcodeValues(oldBarcodeValues)
            }
        } else {
            barCodeProcessed(data)
        }
    }

    const codeScanner = useCodeScanner({
        codeTypes: ['ean-13','code-128', 'qr', 'code-39', 'code-93', 'ean-8', 'upc-e', 'upc-a', 'itf'],
        onCodeScanned: handleBarCodeScanned,
    })

    return (
        <View style={styles.container}>
        {hasCameraPermission === undefined && 
            <Text>{content.camera_components.loading_camera}</Text>
        }
        {hasCameraPermission === false && [
            <Text>{content.camera_components.no_access}</Text>,
            <Button
            title={content.camera_components.cancel_scanning}
            onPress={() => handleBarCodeScanned(undefined)}
            key={1}
            style={styles.buttonStyle}
            />
        ]}
        <Space height={96} />
        {!scanned && hasCameraPermission && [
            <Camera
                device={device}
                audio={false}
                video={false}
                codeScanner={codeScanner}
                isActive={true}
                style={styles.cameraStyle}
            />,
            <Space height={100} />,
            <Button
                title={content.camera_components.cancel_scanning}
                onPress={() => handleBarCodeScanned(undefined)}
                style={styles.buttonStyle}
            />
        ]}
        </View>
    );
}

export default CameraComponent

const styles = StyleSheet.create({
    cameraStyle: {
        //position:'absolute',
        width:'100%',
        height:'60%',
        alignSelf:'center'
    },
    buttonStyle: {
      backgroundColor: colors.brightOrange,
      width: '90%',
      alignSelf: 'center'
    },
    container: {
        flex: 1,
        backgroundColor: backgroundColors.darkCharcoal,
    }
})
